import { render, staticRenderFns } from "./useCoupon.vue?vue&type=template&id=c4548ecc&scoped=true"
import script from "./useCoupon.vue?vue&type=script&lang=js"
export * from "./useCoupon.vue?vue&type=script&lang=js"
import style0 from "./useCoupon.vue?vue&type=style&index=0&id=c4548ecc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4548ecc",
  null
  
)

export default component.exports